module.exports = __webpack_public_path__ + "static/media/yo_peque.9928f397.png";